export default __webpack_public_path__ + "static/media/upload_image.70c9c7e2.svg";